import { includes, __ } from "ramda";

const isDisabledValue = includes(__, [true, 'true', 'disabled']);

export {
    isDisabledValue,
};

